module.exports = __webpack_public_path__ + "assets/f5f50cb052cc518aec82ad216186246d.mp3";